import React, { useRef, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { connect } from "react-redux";

import { ApplicationState } from "../../store";
import {
  actionCreators,
  GalleryElement,
  GalleryState,
} from "../../store/Gallery";

import PopupGallerySlider from "./PopupGallerySlider";
import GalleryGrid from "./GalleryGrid";

import logo from "../resources/images/logo_1.png";
import "../styles/popupGallery.css";

type Props = RouteComponentProps<{ parentId: string }> &
  GalleryState &
  typeof actionCreators;

const PopupGallery: React.FC<Props> = (props) => {
  const parentId = Number(props.match?.params?.parentId ?? 0);

  const childElements = React.useMemo<GalleryElement[]>(
    () => props.galleryElements.filter((g) => g.parentId === parentId),
    [props.galleryElements, parentId]
  );

  const imageDivRef = useRef<HTMLDivElement | null>(null);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  if (!props.match || childElements.length === 0) return null;

  const showPreviousElement = () => {
    setCurrentIndex(
      currentIndex === 0
        ? childElements.length - 1
        : (currentIndex - 1) % childElements.length
    );
  };

  const showNextElement = () => {
    setCurrentIndex((currentIndex + 1) % childElements.length);
  };

  const showSelectedElement = (element: GalleryElement) => {
    setCurrentIndex(childElements.indexOf(element));
    imageDivRef.current?.scrollIntoView({
      behavior: "auto",
    });
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    switch (e.key) {
      case "ArrowLeft":
        showPreviousElement();
        imageDivRef?.current?.focus();
        break;
      case "ArrowRight":
        showNextElement();
        imageDivRef?.current?.focus();
        break;
      default:
        break;
    }
  };

  return (
    <div
      ref={imageDivRef}
      className="img-player"
      onKeyDown={onKeyDown}
      tabIndex={0}
    >
      <div className="image-browser-body" data-parent-element-id={parentId}>
        <div className="container-fluid portfolio-top">
          <img
            className="portfolio-top-icon"
            src={logo}
            alt="tribeca design studio"
          />
        </div>
        <PopupGallerySlider
          element={childElements[currentIndex]}
          onNextClick={showNextElement}
          onPreviousClick={showPreviousElement}
        />
        <div id="project-details"></div>
        <GalleryGrid
          containerClassName="p-grid popup-gallery-grid"
          elements={childElements}
          onGalleryItemClick={showSelectedElement}
          scrollableElementClassName="MuiDialog-scrollBody"
        />
      </div>
    </div>
  );
};

export default connect(
  (state: ApplicationState) => state.gallery,
  actionCreators
)(withRouter(PopupGallery as any));
